import React from 'react';
import { BRAND_FILTER_UNASSIGNED } from '../utils/contentScope';

const brandIdOfSalon = (salon) => String(salon?.brand?._id || salon?.brand || '');

const isSentinelBrand = (value) =>
  !value || value === BRAND_FILTER_UNASSIGNED;

const BrandBranchFilterFields = ({
  portal,
  filters,
  onChange,
  brands,
  salons,
  brandLabel = 'Brand',
  salonLabel = 'Branch',
  allSalonLabel = 'All Branches',
  includeUnassignedOption = false,
  brandSelectValue
}) => {
  const extraBrandOptions = includeUnassignedOption
    ? [{ value: BRAND_FILTER_UNASSIGNED, label: 'Unassigned' }]
    : [];
  const showBrand = Boolean(portal?.showBrandPicker) || extraBrandOptions.length > 0;
  if (!showBrand && !portal?.showBranchPicker) return null;

  const selectedBrand = brandSelectValue !== undefined
    ? brandSelectValue
    : (filters.brandId || '');
  const realBrandId = isSentinelBrand(selectedBrand) ? '' : selectedBrand;
  const salonDisabled = portal.showBrandPicker && !realBrandId;

  return (
    <>
      {showBrand && (
        <div className="form-group">
          <label>{brandLabel}</label>
          <select
            value={selectedBrand}
            disabled={portal.showBrandPicker === false && extraBrandOptions.length === 0}
            onChange={(e) => {
              onChange('brandId', e.target.value);
              onChange('salonId', '');
            }}
          >
            <option value="">All</option>
            {extraBrandOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
            {portal.showBrandPicker && (brands || []).map((brand) => (
              <option key={brand._id} value={brand._id}>
                {brand.name}
              </option>
            ))}
          </select>
        </div>
      )}
      {portal.showBranchPicker && selectedBrand !== BRAND_FILTER_UNASSIGNED && (
        <div className="form-group">
          <label>{salonLabel}</label>
          <select
            value={filters.salonId || ''}
            onChange={(e) => onChange('salonId', e.target.value)}
            disabled={salonDisabled}
          >
            <option value="">
              {allSalonLabel}{realBrandId ? ' (in selected brand)' : ''}
            </option>
            {(salons || [])
              .filter((salon) => !realBrandId || brandIdOfSalon(salon) === String(realBrandId))
              .map((salon) => (
                <option key={salon._id} value={salon._id}>
                  {salon.brand?.name || 'N/A'} - {salon.name} {salon.branch ? `(${salon.branch})` : ''}
                </option>
              ))}
          </select>
        </div>
      )}
    </>
  );
};

export default BrandBranchFilterFields;
